import { useEffect, useRef } from "react";
import { AlertCircle } from "lucide-react";

// WCAG 2.2: errors listed in one place, announced, and the first invalid field receives focus.
export const ErrorSummary = ({ errors = [], title = "Please fix the following before continuing", testid = "error-summary" }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!errors.length) return;
    ref.current?.focus();
    const first = errors.find((e) => e.field);
    if (first) {
      const el = document.querySelector(`[data-field="${first.field}"]`) || document.querySelector(`[data-testid="${first.field}"]`);
      el?.setAttribute("aria-invalid", "true");
      setTimeout(() => el?.focus(), 50);
    }
  }, [errors]);
  if (!errors.length) return null;
  return (
    <div ref={ref} tabIndex={-1} role="alert" aria-labelledby={`${testid}-title`} className="mb-5 p-4 rounded-xl border-2 border-red-700 bg-red-50 text-[#0a0d12] outline-none" data-testid={testid}>
      <div id={`${testid}-title`} className="flex items-center gap-2 font-bold text-red-800 text-sm"><AlertCircle size={16} /> {title}</div>
      <ul className="mt-2 list-disc pl-6 text-sm space-y-1">
        {errors.map((e, i) => (
          <li key={e.field || e.message}>{e.field ? <a href={`#${e.field}`} onClick={(ev) => { ev.preventDefault(); (document.querySelector(`[data-field="${e.field}"]`) || document.querySelector(`[data-testid="${e.field}"]`))?.focus(); }} className="underline text-red-900">{e.message}</a> : e.message}</li>
        ))}
      </ul>
    </div>
  );
};
